import { render, staticRenderFns } from "./ViewPatientAdd.vue?vue&type=template&id=686d268f&"
import script from "./ViewPatientAdd.vue?vue&type=script&lang=js&"
export * from "./ViewPatientAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports